<style lang="scss">
html,
body {
  font-size: 12px;
  padding: 0;
  margin: 0;
  height: 100%;
}
.all-height {
  .el-dialog {
    margin: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    width: 100vw;
    height: 100vh;
    padding: 0 !important;
  }
}
#app {
  height: 100%;
}
.main {
  display: flex;
  height: calc(100% - 120px);
  width: 100%;
  .left {
    height: 100%;
    width: 147px;
    flex-shrink: 0;
    flex-grow: 0;
    background-image: url(./assets/left_bg.png);
    background-repeat: repeat-y;
  }
  .right {
    height: 100%;
    width: 147px;
    flex-shrink: 0;
    flex-grow: 0;
    background-image: url(./assets/right_bg.png);
    background-repeat: repeat-y;
  }
  .center {
    background-image: url(./assets/main_bg.png);
    background-repeat: repeat;
    flex: 1;
    .top {
      height: 80px;
    }
    .outer {
      height: calc(100% - 80px - 80px);
      overflow-x: hidden;
      overflow-y: auto;
    }
    .book-wrapper {
      z-index: 999;
    }
    .bottom {
      height: 80px;
    }
  }
}

.custom-scrollbar {
  overflow-y: scroll;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.blue-btn {
  display: block;
  text-decoration: unset;
  color: #fff;
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #1b7fcb;
  border-radius: 3px;
  &:hover {
    background: #146eb3;
  }
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #dfa386;
  border-radius: 12px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #412828;
  border-radius: 12px;
}
.book-wrapper {
  padding-left: 90px;
  padding-right: 90px;
  background-image: url(./assets/main_box_bg.png);
  background-repeat: repeat-y;
  width: 1200px;
  margin: 0 auto;
}
.book-box {
  width: 100px;
  height: 140px;
  margin: 6px 24px;
  margin-bottom: 60px;
  position: relative;
  margin-right: 20px;
  cursor: pointer;
  &:hover {
    .qrcode-corner {
      visibility: visible;
      opacity: 1;
    }
  }
  .qrcode-corner {
    transition: all 0.3s;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    left: 0;
    top: 0;
    width: 30px;
    height: 30px;
    background-image: url(./assets/qrcode_corner.png);
    background-size: cover;
  }
  &:last-child {
    margin-right: auto;
  }

  & > img {
    height: 140px;
  }
  & img {
    width: 100%;
  }
}

@media screen and (max-width: 800px) {
  #app {
    overflow: hidden;
  }
  .d-flex.flex-wrap {
    position: relative;
  }
  .book-box {
    width: 24vw;
    height: 22vh;
    img {
      position: relative;
      z-index: 2;
      height: 90%;
    }
  }
  .book-box:nth-child(2n) {
    &::after {
      display: block;
      content: '';
      background-image: url(./assets/main_box_bg_mb2.png);
      background-size: 100%;
      width: 80vw;
      height: 7vh;
      position: absolute;
      left: -48vw;
      bottom: -2vh;
      z-index: 0;
    }
  }
  .book-box:last-child {
    &::after {
      display: block;
      content: '';
      background-image: url(./assets/main_box_bg_mb2.png);
      background-size: 100%;
      width: 80vw;
      height: 7vh;
      position: absolute;
      // left: -11vw;
      bottom: -2vh;
      z-index: 0;
    }
  }
  .book-wrapper {
    width: 80vw;
    padding-left: 10px;
    padding-right: 0;
    background-image: none;
  }
  .main {
    .left,
    .right {
      width: 10px;
      background-image: url(./assets/main_bg.png);
    }
  }
  .main {
    .center {
      .top {
        height: 10px;
      }
    }
    height: 100%;
  }
  .el-dialog {
    width: 100% !important;
  }
  #img2 {
    top: -15px !important;
  }
  .close-btn {
    left: 12px !important;
    top: 5px !important;
    font-size: 20px !important;
  }
}
.close-btn {
  position: absolute;
  right: 30px;
  top: 30px;
  color: #fff;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 30px;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close-btn-img {
  width: 30px;
  height: 30px;
}
</style>

<template>
  <div id="app">
    <Header
      @search="handlerSearch"
      @category="handlerCategory"
      @reset="reset"
    ></Header>
    <el-dialog
      :visible.sync="bookModalFlag"
      width="100vw"
      height="100vh"
      class="all-height"
    >
      <div style="position: relative;height: 100%">
        <span
          @click="hideAllModal"
          class="close-btn"
        >
          <img
            class="close-btn-img"
            :src="require('./assets/close-icon.png')"
            alt
          />
        </span>
        <iframe
          v-if="current.url"
          style="height: 100%; width: 100%"
          :src="current.url + '?r=' + getRandom()"
          frameborder="0"
        ></iframe>
      </div>
    </el-dialog>
    <el-dialog
      title="简介"
      :visible.sync="dialogVisible"
      width="450px"
      height="300px"
    >
      <div class="d-flex">
        <div style="flex: 1; text-align:center;position: relative;margin-top: 20px;margin-right: 10px">
          <img
            style=" bottom: -25px;left: 0;  position: absolute;"
            :src="require('./assets/modal_book_bg.png')"
            alt
          />
          <img
            id="img2"
            style="width: 100px; height: 142px; top:-35px;left:38px; box-shadow: 0 0 5px #ddd;position: absolute"
            :src="'http://www.heremay.com/image/bookcase/' + current.img"
            alt
          />
        </div>
        <div style="flex: 1">
          <p style="font-weight: bold">{{current.title}}</p>
          <p>{{ current.des }}</p>
          <a
            @click.prevent="showBookModal"
            href="#"
            class="blue-btn"
          >查看</a>
        </div>
      </div>
      <div style="text-align: center; margin-top: 50px; font-size:12px; color: #999">发布时间：{{ current.date }}</div>
    </el-dialog>

    <div class="main">
      <div class="left"></div>
      <div class="center">
        <div class="top"></div>
        <div class="outer custom-scrollbar">
          <div class="book-wrapper">
            <div
              class="d-flex flex-wrap"
              style="justify-content:flex-start;padding-top: 25px"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.title"
                placement="top"
                v-for="(item, index) in items"
                :key="index"
              >
                <div
                  class="book-box"
                  @click="openModal(item)"
                  @mouseleave="blueCodeOut(item)"
                >
                  <div
                    class="qrcode-corner"
                    @mousemove="blueCodeHover(item)"
                  ></div>
                  <img
                    @click="handlerClose"
                    :src="'http://www.heremay.com/image/bookcase/' + item.img"
                    alt
                  />
                  <div
                    v-if="item.showQrCode"
                    style="width: 100%; height: 100%; position: absolute; left:0; top: 0;background:#3031332b"
                    @click="hideQrCode(item)"
                  >
                    <div
                      :id="'qrcode' + item.id"
                      style="position: absolute; top: 30px;left: 10px;width:80px!important;height: 80px"
                    ></div>
                  </div>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <div class="right"></div>
    </div>
    <Footer></Footer>
  </div>
</template>


<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import { DATA } from './store/data.js';
import _cloneDeep from 'lodash/cloneDeep';
function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--; ) document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
  }
}

export default {
  components: {
    Header,
    Footer
  },

  methods: {
    getRandom() {
      return Math.ceil(Math.random() * 1000);
    },
    openModal(item) {
      this.$set(this.current, 'title', item.title);
      this.$set(this.current, 'img', item.img);
      this.$set(this.current, 'url', item.url);
      this.$set(this.current, 'des', item.des);
      this.$set(this.current, 'date', item.date);
    },

    hideAllModal() {
      this.$set(this.current, 'url', '');
      clearAllCookie();
      localStorage.clear();
      sessionStorage.clear();
      this.bookModalFlag = false;
      this.dialogVisible = false;
    },

    showBookModal() {
      this.bookModalFlag = true;
    },

    reset() {
      this.items = _cloneDeep(this.originData);
    },
    handlerClose() {
      this.dialogVisible = true;
    },

    makeCode(content, id) {
      const qrcode = new QRCode(document.getElementById('qrcode' + id), {
        width: 80,
        height: 80
      });
      qrcode.makeCode(content);
    },
    showQrCode(item) {
      item.showQrCode = true;

      this.$forceUpdate();
      this.$nextTick(() => {
        this.makeCode(item.url, item.id);
      });
    },

    blueCodeHover(item) {
      const id = item.id;
      console.log('1 :>> ', 1);
      if (this.hoverBlueQrCodeId != id) {
        this.showQrCode(item);
        this.hoverBlueQrCodeId = id;
      }
    },
    blueCodeOut(item) {
      console.log('2 :>> ', 2);
      this.hideQrCode(item);
      this.hoverBlueQrCodeId = '';
    },
    hideQrCode(item) {
      item.showQrCode = false;
      this.$forceUpdate();
    },
    handlerSearch(val) {
      const data = _cloneDeep(this.originData);
      if (val === '') {
        this.items = data;
        return;
      }
      this.items = data.filter(e => e.title.includes(val));
    },
    handlerCategory(val) {
      const data = _cloneDeep(this.originData);
      if (val === '') {
        this.items = data;
        return;
      }
      this.items = data.filter(e => e.category === val);
    }
  },
  data() {
    return {
      current: {
        title: '',
        img: '',
        url: '',
        des: ''
      },
      dialogVisible: false,
      bookModalFlag: false,
      items: DATA,
      originData: _cloneDeep(DATA)
      // items: [{}, {}, {}, {}, {}, {}, {}, {}, {}]
    };
  }
};
</script>
